import {
  useEffect,
  useState,
} from "react";

import {
  loadHistoricoTurma,
} from "../turmas.service";

import type {
  HistoricoAulaTurma,
} from "../turmas.service";

import "./HistoricoTurma.css";


type HistoricoTurmaProps = {
  turmaId: string;

  refreshKey?: number;

  onAbrirChamada: (
    data: string,
  ) => void;
};


function formatDateBR(
  value: string,
) {
  const [
    year,
    month,
    day,
  ] =
    value.split("-");

  return `${day}/${month}/${year}`;
}


function formatHour(
  value: number,
) {
  const hours =
    Math.floor(
      value,
    );

  const minutes =
    Math.round(
      (
        value -
        hours
      ) *
        60,
    );

  return `${String(
    hours,
  ).padStart(
    2,
    "0",
  )}:${String(
    minutes,
  ).padStart(
    2,
    "0",
  )}`;
}


function formatBRL(
  value: number,
) {
  return new Intl.NumberFormat(
    "pt-BR",
    {
      style: "currency",
      currency: "BRL",
    },
  ).format(value);
}


export default function HistoricoTurma({
  turmaId,
  refreshKey = 0,
  onAbrirChamada,
}: HistoricoTurmaProps) {
  const [
    aulas,
    setAulas,
  ] =
    useState<
      HistoricoAulaTurma[]
    >([]);


  const [
    loading,
    setLoading,
  ] =
    useState(true);


  const [
    error,
    setError,
  ] =
    useState("");


  useEffect(() => {
    let active =
      true;


    async function load() {
      try {
        setLoading(
          true,
        );

        setError("");


        const result =
          await loadHistoricoTurma(
            turmaId,
          );


        if (!active) {
          return;
        }


        setAulas(
          result,
        );
      } catch (err) {
        console.error(
          err,
        );


        if (active) {
          setError(
            "Não foi possível carregar o histórico de aulas.",
          );
        }
      } finally {
        if (active) {
          setLoading(
            false,
          );
        }
      }
    }


    load();


    return () => {
      active =
        false;
    };
  }, [
  turmaId,
  refreshKey,
]);


  return (
    <section className="historico-turma">
      <div className="historico-turma-header">
        <div>
          <span className="turmas-eyebrow">
            HISTÓRICO
          </span>

          <h3>
            Aulas realizadas
          </h3>
        </div>

        <div className="historico-turma-count">
          {aulas.length}
        </div>
      </div>


      {loading ? (
        <div className="turmas-empty">
          Carregando histórico...
        </div>
      ) : error ? (
        <div className="turmas-form-error">
          {error}
        </div>
      ) : aulas.length === 0 ? (
        <div className="turmas-empty">
          <strong>
            Nenhuma aula registrada.
          </strong>

          <span>
            As chamadas confirmadas aparecerão aqui.
          </span>
        </div>
      ) : (
        <div className="historico-turma-list">
          {aulas.map(
            (aula) => (
              <div
                key={
                  aula.aulaId
                }
                className="historico-aula-card"
              >
                <div className="historico-aula-main">
                  <strong>
                    {formatDateBR(
                      aula.data,
                    )}
                  </strong>

                  <span>
                    {formatHour(
                      aula.hora,
                    )}
                  </span>
                </div>


                <div className="historico-aula-stats">
                  <div>
                    <span>
                      Presentes
                    </span>

                    <strong>
                      {
                        aula.presentes
                      }
                    </strong>
                  </div>

                  <div>
                    <span>
                      Faltas
                    </span>

                    <strong>
                      {
                        aula.faltas
                      }
                    </strong>
                  </div>

                  <div>
                    <span>
                      Avulsas
                    </span>

                    <strong>
                      {
                        aula.avulsas
                      }
                    </strong>
                  </div>

                  <div>
                    <span>
                      Valor avulsas
                    </span>

                    <strong>
                      {formatBRL(
                        aula.valorAvulsas,
                      )}
                    </strong>
                  </div>
                </div>


                <button
                  type="button"
                  className="historico-aula-open"
                  onClick={() =>
                    onAbrirChamada(
                      aula.data,
                    )
                  }
                >
                  Ver chamada
                </button>
              </div>
            ),
          )}
        </div>
      )}
    </section>
  );
}